import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortalOutlinedPrintIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 17 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M3.0293 7C3.30544 7 3.5293 6.77614 3.5293 6.5C3.5293 6.22386 3.30544 6 3.0293 6C2.75315 6 2.5293 6.22386 2.5293 6.5C2.5293 6.77614 2.75315 7 3.0293 7Z",
			fill: "#4B7987"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5293 0C4.42473 0 3.5293 0.89543 3.5293 2V4H2.5293C1.42473 4 0.529297 4.89543 0.529297 6V9C0.529297 10.1046 1.42473 11 2.5293 11H3.5293V12C3.5293 13.1046 4.42473 14 5.5293 14H11.5293C12.6339 14 13.5293 13.1046 13.5293 12V11H14.5293C15.6339 11 16.5293 10.1046 16.5293 9V6C16.5293 4.89543 15.6339 4 14.5293 4H13.5293V2C13.5293 0.895431 12.6339 0 11.5293 0H5.5293ZM4.5293 2C4.5293 1.44772 4.97701 1 5.5293 1H11.5293C12.0816 1 12.5293 1.44772 12.5293 2V4H4.5293V2ZM5.5293 7C4.42473 7 3.5293 7.89543 3.5293 9V10H2.5293C1.97701 10 1.5293 9.55228 1.5293 9V6C1.5293 5.44772 1.97701 5 2.5293 5H14.5293C15.0816 5 15.5293 5.44772 15.5293 6V9C15.5293 9.55228 15.0816 10 14.5293 10H13.5293V9C13.5293 7.89543 12.6339 7 11.5293 7H5.5293ZM12.5293 9V12C12.5293 12.5523 12.0816 13 11.5293 13H5.5293C4.97701 13 4.5293 12.5523 4.5293 12V9C4.5293 8.44772 4.97701 8 5.5293 8H11.5293C12.0816 8 12.5293 8.44772 12.5293 9Z",
			fill: "#4B7987"
		})
	]
});
const ForwardRef = forwardRef(SvgPortalOutlinedPrintIcon);
const Memo = memo(ForwardRef);
export default Memo;
